import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })

export class PortalOverlayService {

	private owner: unknown = null;

	isOpen(owner: unknown): boolean {
		return this.owner === owner && owner !== null;
	}

	// Claims the single open slot, implicitly closing whatever held it.
	open(owner: unknown): void {
		this.owner = owner;
	}

	// Only the current owner can close — a stale close() must not clobber whatever
	// was opened after it.
	close(owner: unknown): void {
		if (this.owner !== owner) return;
		this.owner = null;
	}

	toggle(owner: unknown): void {
		this.isOpen(owner) ? this.close(owner) : this.open(owner);
	}
}
